'use strict';

import React              from 'react';
import { BrowserRouter, Route, Switch} from 'react-router-dom';
import CurrentUserActions from './actions/CurrentUserActions';
// import CurrentUserStore   from './stores/CurrentUserStore';
import NotFoundPage from './pages/NotFoundPage';
import SignupPage from './pages/SignupPage';


import LoginPage from './pages/LoginPage';
import Header             from './components/Header';


class App extends React.Component {

  constructor(props) {
    super(props);

    this.onUserChange = this.onUserChange.bind(this);

    this.state = {
      currentUser: {}
    };
  }

  onUserChange(err, user) {
    if ( err ) {
      this.setState({ error: err });
    } else {
      this.setState({ currentUser: user || {}, error: null });
    }
  }

  componentWillMount() {
    console.log('About to mount App');
  }



  componentWillUnmount() {
    this.unsubscribe();
  }

  renderChildren() {
    return React.cloneElement(this.props.children, {
      params: this.props.params,
      query: this.props.query,
      currentUser: this.state.currentUser
    });
  }

  render() {
    return(
      <BrowserRouter>
        <div>
          <Switch>
              <Route path="/sign-up" component={SignupPage} />
              <Route path="/login" component={LoginPage} />
              <Route path="/home" component={Header} />
              <Route component={NotFoundPage} />
          </Switch>
        </div>
      </BrowserRouter>);
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js